import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  ToastSuccessComponent
} from '../../parts/toast-success/toast-success.component';
import {MatSnackBar} from '@angular/material';
import {DialogsService} from '../../services/dialog.service';
import { RealtorPortalService } from '../../services/network/realtor-portal.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  emailAddress: string;
  resettingEmail = false;

  constructor(private realtorPortalService: RealtorPortalService,
              private router: Router, private snackBar: MatSnackBar,
              private dialogService: DialogsService) {}

  ngOnInit() {}

  get canResetEmail() { return this.emailAddress; }

  reset() {
    this.dialogService.confirm('Confirm',
                               'Are you sure you want to reset your password?')
        .subscribe(result => {
          if (!result) {
            return;
          }
          this.resettingEmail = true;


          this.realtorPortalService.sendResetRequest(this.emailAddress)
              .then(() => {
                this.resettingEmail = false;

                this.snackBar.openFromComponent(ToastSuccessComponent, {
                  data: 'Password Reset. Check your email for the new password.',
                  duration: 10000,
                  panelClass: ['success-toast']
                });
                this.router.navigateByUrl('/log-in');
              });
        });
  }
}
